import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ServiceKeyGenericDialogComponent } from "../service-key-generic-dialog/service-key-generic-dialog.component";
import { UserServiceKeyStatus } from "src/app/models/user/userServiceKeyStatus";
import { SUAService } from "src/app/services/sua.service";
import { ServiceKeyDialogResponse } from "src/app/models/common/serviceKeyDialogResponse";
import { MessageBroadcastService } from "src/app/services/message-broadcast.service";
import { BroadcastMessageEvent } from "src/app/core/constants/BroadcastMessageEvent";

@Component({
  selector: 'app-set-service-key',
  templateUrl: './set-service-key.component.html',
  styleUrls: ['./set-service-key.component.scss']
})
export class SetServiceKeyComponent {
  public packageFile: any = { name: "" };
  public error: boolean = false;
  public showWarningBanner: boolean = true;
  public showSetServiceKeyBanner: boolean = false;
  public showWarning: boolean = false;
  public setClicked: boolean = false;
  public fileFormatIncorrect: boolean = false;
  public serviceKeyDialogResponse = ServiceKeyDialogResponse;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, public matDialogRef: MatDialogRef<SetServiceKeyComponent>, 
  public dialog: MatDialog, private suaService: SUAService,private messageBroadcastService:MessageBroadcastService) {

  }
  ngOnInit() {
    switch (this.dialogData) {
      case UserServiceKeyStatus.ValidKey:
        this.showSetServiceKeyBanner = true;
        this.showWarningBanner = false;
        break;
      case UserServiceKeyStatus.NoKey:
        this.showWarningBanner = true;
        this.showSetServiceKeyBanner = false;
        this.showWarning = true;
        break;
      case UserServiceKeyStatus.ExpiredKey:
        this.showWarningBanner = true;
        this.showSetServiceKeyBanner = false;
        this.showWarning = false;
        break;

      default:
        this.showSetServiceKeyBanner = true;
        this.showWarningBanner = false;       
        break;
    }
  }
  openFileSelectWindow(fileuploadTextBox, fileUplaod) {
    fileUplaod.click();
    //mark file upload control as touched to show validation
    fileuploadTextBox.control.markAsTouched();
  }
  onFileSelected(event) {
    const file: File = event.target.files[0];
    if (file) {
      this.checkFileFormat(file.name);
      this.packageFile = file;
    }
  }
  setServiceKey() {    
    const formData = new FormData();
    formData.append('file', this.packageFile, this.packageFile.name);
    this.setClicked = true;
    
    this.suaService.sendServiceUserKey(formData).subscribe({next: (data)=>{  
      this.cancel(ServiceKeyDialogResponse.KeyUpdationSuccessfull);    
      if(data){
        this.suaService.serviceKeyStatus.next('success');
        this.messageBroadcastService.broadCast({event:BroadcastMessageEvent.suaKeyUpdates})
        this.dialog.open(ServiceKeyGenericDialogComponent, {
          disableClose: true,
          autoFocus: false,
          data: {status:'success'}
        })
      }
      else{
        
      }
    }, error: (err)=>{ 
      this.cancel();   
      this.dialog.open(ServiceKeyGenericDialogComponent, {
        disableClose: true,
        autoFocus: false,
        data: {status: 'failure', description: err}
      })
    }})
   
  }
  openSetServiceKeyBanner() {
    this.showSetServiceKeyBanner = true;
    this.showWarningBanner = false;
  }
  checkFileFormat(fileName){
    let format = fileName.substring(fileName.lastIndexOf('.'));
    if(format !== '.xml'){
      this.fileFormatIncorrect = true;
    }
    else{
      this.fileFormatIncorrect = false;
    }
  }
  cancel(result = ServiceKeyDialogResponse.Cancel) {
    this.matDialogRef.close(result);
  }
}